import { u as p } from "./use-product-y102e61c.js";
import { u as d, o as l, b as u, c as m, e as f, g as a, f as s, n as o } from "./define-element-XpjsV6s1.js";
import { _ as v } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const _ = {
  class: "offset-product-list-sort",
  ref: "container"
}, b = ["aria-pressed"], y = ["aria-pressed"], S = ["aria-pressed"], k = ["aria-pressed"], C = {
  __name: "ProductListSort",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(n) {
    const i = n, { sortBy: e } = p(), c = d("container");
    return l(() => {
      u(c.value, i.inheritStyle);
    }), ($, t) => (m(), f("div", _, [
      a("button", {
        type: "button",
        onClick: t[0] || (t[0] = (r) => e.value = ["price", "desc"]),
        class: o([s(e)[0] == "price" && s(e)[1] == "desc" ? "active" : ""]),
        "aria-pressed": s(e)[0] == "price" && s(e)[1] == "desc"
      }, " High $ ", 10, b),
      a("button", {
        type: "button",
        onClick: t[1] || (t[1] = (r) => e.value = ["price", "asc"]),
        class: o([s(e)[0] == "price" && s(e)[1] == "asc" ? "active" : ""]),
        "aria-pressed": s(e)[0] == "price" && s(e)[1] == "asc"
      }, " Low $ ", 10, y),
      a("button", {
        type: "button",
        onClick: t[2] || (t[2] = (r) => e.value = ["name", "asc"]),
        class: o([s(e)[0] == "name" && s(e)[1] == "asc" ? "active" : ""]),
        "aria-pressed": s(e)[0] == "name" && s(e)[1] == "asc"
      }, " A-Z ", 10, S),
      a("button", {
        type: "button",
        onClick: t[3] || (t[3] = (r) => e.value = ["name", "desc"]),
        class: o([s(e)[0] == "name" && s(e)[1] == "desc" ? "active" : ""]),
        "aria-pressed": s(e)[0] == "name" && s(e)[1] == "desc"
      }, " Z-A ", 10, k)
    ], 512));
  }
}, x = /* @__PURE__ */ v(C, [["__scopeId", "data-v-2797c95f"]]);
export {
  x as P
};
